import { request } from './client';

export const apiGetAllBanners = () => request('/banners/admin/all');

export const apiCreateBanner = (formData) =>
  request('/banners', { method: 'POST', body: formData });

export const apiUpdateBanner = (id, formData) =>
  request(`/banners/${id}`, { method: 'PUT', body: formData });

export const apiDeleteBanner = (id) =>
  request(`/banners/${id}`, { method: 'DELETE' });

export const apiToggleBanner = (id) =>
  request(`/banners/${id}/toggle`, { method: 'PUT' });
